import { Http } from "../Http";
export class aarolesAPI {
 
  public static  getAaroles(input: any){

    var url = "api/getaarolesbystatus/Active" ;
   // alert("url"+url);
    if (input === "") {
      return { data: [] };
    }

    const resultMethod = Http.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {
        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    return resultMethod;  
  }
  public static getAarolesByRoleId(input: any) {
    var url = "/api/getAaroles/" + input.input;
    if (input.id === "") {
        return { data: [] };
    }
    const resultMethod = Http.axios()
        .get(url, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then(res => {
            return res;
        })
        .catch((e: any) => {
            return e.response;
        });
    return resultMethod;
}

    public static saveAaroles(input: any) {
 
        var obj=JSON.stringify(input);
        var url="api/saveAaroles";
        // if(input.jobId>0 ){
        //   //var url="api/updateSchedulerJobsRepository";
        // }
       
        const resultMethod = Http.axios().post(url, obj,
          {
            headers: {
              'Content-Type': 'application/json',
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "*",
              "Access-Control-Allow-Headers": "*"
            }
          })
          .then(res => {
             
            return res;
          }).catch((e: any) => {
          
            return e.response;
          });
        return resultMethod;
}

public static DeleteAaroles(input: any) {
 
  var obj=JSON.stringify(input);
  var url="api/deleteAaroles";

  // if(input.jobId>0 ){
  //   //var url="api/updateSchedulerJobsRepository";
  // }
 
  const resultMethod = Http.axios().post(url, obj,
    {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
    return res;
    }).catch((e: any) => {
 
      return e.response;
    });
  return resultMethod;
}
}